import React, { useEffect, useState } from "react";
import axios from "axios";
import Navbar from "../../components/navbar/Navbar";
import Footer from "../../components/footer/Footer";
import { MdDelete } from "react-icons/md";

const Blog = () => {
  const admin = true;
  const [blogs, setBlogs] = useState([]);
  const [newBlogTitle, setNewBlogTitle] = useState("");
  const [newBlogContent, setNewBlogContent] = useState("");

  // Fetch all blogs
  const fetchBlogs = async () => {
    const res = await axios.get("http://localhost:5000/api/blogs");
    setBlogs(res.data);
  };

  useEffect(() => {
    fetchBlogs();
  }, []);

  // Add blog
  const addBlog = async () => {
    if (!admin || !newBlogTitle.trim() || !newBlogContent.trim()) return;

    await axios.post("http://localhost:5000/api/blogs", {
      title: newBlogTitle,
      content: newBlogContent,
    });

    setNewBlogTitle("");
    setNewBlogContent("");
    fetchBlogs();
  };

  // Delete blog
  const deleteBlog = async (id) => {
    if (!admin) return;
    await axios.delete(`http://localhost:5000/api/blogs/${id}`);
    fetchBlogs();
  };

  return (
    <div className="bg-[#06011A] text-white min-h-screen">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 py-8">
        <h1 className="text-4xl font-semibold mb-6">Blog</h1>

        {admin && (
          <div className="mb-8">
            <input
              type="text"
              placeholder="Blog Title"
              value={newBlogTitle}
              onChange={(e) => setNewBlogTitle(e.target.value)}
              className="input bg-[#1B1C2D] border border-[#363636] text-white w-full mb-4"
            />
            <textarea
              placeholder="Write your blog content here..."
              value={newBlogContent}
              onChange={(e) => setNewBlogContent(e.target.value)}
              className="textarea bg-[#1B1C2D] border border-[#363636] text-white w-full h-40"
            ></textarea>
            <button
              onClick={addBlog}
              className="mt-4 secondary-button w-full lg:w-48"
            >
              Add Blog
            </button>
          </div>
        )}

        <div>
          {blogs.map((blog) => (
            <div
              key={blog._id}
              className="bg-[#1B1C2D] p-6 mb-4 rounded-lg relative"
            >
              <h2 className="text-2xl font-bold">{blog.title}</h2>
              <p className="text-sm text-gray-400 mb-2">{blog.date}</p>
              <p>{blog.content}</p>
              {admin && (
                <button
                  onClick={() => deleteBlog(blog._id)}
                  className="absolute top-4 right-4 text-red-500 hover:text-red-700"
                >
                  <MdDelete size={24} />
                </button>
              )}
            </div>
          ))}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Blog;
